<template>
  <div
    v-if="user"
    class="profile p-dropdown"
    @keydown.enter.prevent="toggleMenu"
  >
    <div class="p-dropdown__user">
      <div :style="avatarStyle" class="p-dropdown__avatar">
        <BaseIcon
          v-if="!user.avatar"
          class="p-dropdown__avatar-placeholder"
          glyph="person"
          width="20px"
        />
      </div>
      <div class="p-dropdown__name">{{ userName }}</div>
      <div class="p-dropdown__chevron">
        <BaseIcon
          :title="menuIsOpen ? 'Свернуть' : 'Развернуть'"
          glyph="chevron-down"
          width="10px"
        />
      </div>
    </div>
    <div class="p-dropdown__menu" :class="{ 'is-open': menuIsOpen }">
      <a
        :href="profileLink"
        target="_blank"
        rel="noopener noreferrer"
        title="Перейти в профиль"
        class="p-dropdown__menu-item link"
      >
        <div class="p-dropdown__menu-icon">
          <BaseIcon glyph="person" width="14px" />
        </div>
        Перейти в профиль
      </a>
      <div class="p-dropdown__menu-line"></div>
      <div class="p-dropdown__menu-item mb-s">
        <div class="p-dropdown__menu-icon">
          <BaseIcon glyph="mail" width="15px" />
        </div>
        {{ user.email }}
      </div>
      <div class="p-dropdown__menu-item">
        <div class="p-dropdown__menu-icon">
          <BaseIcon glyph="logo" width="18px" />
        </div>
        Talent&nbsp;ID:
        <span
          class="p-dropdown__menu-item link ml-xs"
          title="Скопировать Talent ID"
          @click="copyId"
          @keydown.enter.prevent="copyId"
          >{{ user.id
          }}<BaseIcon
            v-if="!isCopiedId"
            glyph="edit-copy"
            width="14px"
            title="Скопировать Talent ID"
            class="ml-s"
          /><BaseSpinner size="14px" class="ml-s" v-else />
        </span>
      </div>
      <div class="p-dropdown__menu-line"></div>
      <button
        title="Выйти"
        class="p-dropdown__menu-item logout link"
        @click="handleLogout"
      >
        <div class="p-dropdown__menu-icon">
          <BaseIcon glyph="logout" width="14px" />
        </div>
        Выйти
      </button>
    </div>
  </div>
</template>

<script>
import { copyToClipboard, delay } from "@/utils";
import BaseSpinner from "@/components/base/BaseSpinner";

export default {
  name: "ProfileBlock",
  components: { BaseSpinner },
  props: {
    user: Object,
  },
  data() {
    return {
      menuIsOpen: false,
      isCopiedId: false,
    };
  },
  computed: {
    avatarStyle() {
      if (this.user && this.user.avatar) {
        return {
          backgroundImage: `url(${this.user.avatar})`,
        };
      }
      return null;
    },
    userName() {
      const { last_name, first_name } = this.user;
      const letter = last_name && last_name[0] + ".";
      return `${first_name || ""} ${letter || ""}`;
    },
    profileLink() {
      return process.env.VUE_APP_TALENT_HOST + "/profile";
    },
  },
  methods: {
    toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
    },
    async copyId() {
      copyToClipboard(this.user.id);
      this.isCopiedId = true;
      await delay(1500);
      this.isCopiedId = false;
    },
    async handleLogout() {
      await this.$store.dispatch("user/logOut");
    },
  },
};
</script>

<style lang="less" scoped>
.p-dropdown {
  font-size: 13px;
  line-height: 20/13;
  &__user {
    display: inline-flex;
    align-items: center;
    padding: 5px 17px 5px 6px;
    border-radius: 20px;
    transition: background 0.3s;
    cursor: pointer;
    margin-left: 20px;

    @media screen and (max-width: @screen-lg) {
      margin-left: 10px;
    }
  }

  &:hover &__user {
    background: lighten(@primary-color, 40%);
  }

  &__avatar {
    user-select: none;
    min-width: 30px;
    width: 30px;
    height: 30px;
    background-color: @primary-color;
    background-position: center center;
    background-size: cover;
    color: #fff;
    border: none;
    border-radius: 50%;
    text-align: center;
    line-height: 32 / 11;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.1em;
    text-decoration: none;
    outline: none;
    position: relative;
    margin-right: 10px;

    &-btn {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover &-btn {
      opacity: 1;
    }

    &-placeholder {
      opacity: 1;
      transition: opacity 0.3s;
    }

    &:hover &-placeholder {
      opacity: 0;
    }

    @media screen and (max-width: @screen-xs-max) {
      margin-right: -10px;
    }
  }

  &__name {
    @media screen and (max-width: @screen-xs-max) {
      display: none;
    }
  }

  &__chevron {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s, transform 0.3s;
    margin-left: 25px;
  }

  &:hover &__chevron {
    transform: rotate(-180deg);
    color: @primary-color;
  }

  &__menu {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 15px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(43, 86, 95, 0.25);
    border-radius: @border-radius-xs;
    padding: 20px 24px;
    min-width: 215px;

    &::before {
      content: "";
      position: absolute;
      top: -15px;
      height: 15px;
      left: 0;
      right: 0;
    }

    &.is-open {
      display: block;
    }

    &-item {
      line-height: 20 / 13;
      color: @base-color;
      text-decoration: none;
      display: flex;
      align-items: center;

      &.link:hover {
        color: @primary-color;
      }
    }

    &-icon {
      color: @dark-gray-color;
      width: 26px;
      height: 20px;
      flex: 0 0 26px;
      min-width: 26px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: color 0.3s;
    }

    &-item.link:hover &-icon {
      color: @primary-color;
    }

    &-line {
      height: 1px;
      background: lighten(@primary-color, 40%);
      margin: 10px 0;
    }
  }

  &:hover &__menu {
    display: block;
  }
}
.logout {
  background-color: transparent;
  outline: none;
  border: 0;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-family: inherit;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
</style>
